import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import { calculatePrice, productImage } from '@snapbrains/snapav/src/avantlink';

import Commision from './parts/commission';
import SaleTag, { defaultStyles as defaultSaleStyles } from './parts/sale_tag';
import Price, { defaultStyles } from './parts/price';
import Merchant from './parts/merchant';

export default function ResultBar(props) {
  const { result, isOption, selected } = props;
  const isLoaded = !!result;
  const width = 96;
  const height = 96;
  const image = isLoaded ? productImage(result, width, height) : '';
  const calculatedPricing = isLoaded ? calculatePrice(result) : 0;

  const saleStyles = {
    ...defaultSaleStyles,
    saleTag: {
      ...defaultSaleStyles.saleTag,
      left: 0,
    },
  };

  const priceStyles = {
    ...defaultStyles,
    priceContainerChild: {
      textAlign: 'left',
      margin: 0,
      minWidth: 120,
    },
  };

  return (
    <div className="snapgadget-result-bar">
      <SaleTag
        calculatedPricing={calculatedPricing}
        styles={saleStyles}
      />
      <div style={{ width }}>
        {isLoaded
          ? (
            <img
              src={image}
              style={{ maxWidth: width }}
              alt={result.strProductName}
              aria-hidden="true"
            />
          )
          : <Skeleton style={{ width, maxWidth: width, minHeight: height }} />}
      </div>
      <div className="snapgadget-result-bar-info">
        <div className="snapgadget-result-bar-info-name">
          {isLoaded ? result.strProductName : <Skeleton count={2} width="100%" />}
        </div>
        <div className="snapgadget-result-bar-info-merchant">
          <Merchant result={result} />
          <Commision result={result} />
          {selected && <div className="snapgadget-result-bar-select-wrap">(Press enter to select this link)</div>}
        </div>
      </div>
      <div className="snapgadget-result-bar-info-price">
        <Price
          result={result}
          calculatedPricing={calculatedPricing}
          styles={priceStyles}
        />
        {isOption
          ? (
            <div className="snapgadget-result-bar-select-wrap">
              <span className="snapgadget-result-bar-select">SELECT</span>
            </div>
          )
          : null}
      </div>
    </div>
  );
}

ResultBar.propTypes = {
  result: PropTypes.shape({
    strProductName: PropTypes.string,
  }).isRequired,
  selected: PropTypes.bool,
  isOption: PropTypes.bool,
};

ResultBar.defaultProps = {
  selected: false,
  isOption: false,
};
